import { getCookieValue, setCookie } from '@/core/utils/cookies.client';
import { createId } from '@/core/utils/string';
import { DEVICE_ID } from './cookies.config';

export function getDeviceIdCookie(): Promise<string | null> {
	return getCookieValue(DEVICE_ID);
}

async function setDeviceIdCookie(value: string): Promise<void> {
	await setCookie(DEVICE_ID, value);
}

export async function getOrCreateDeviceIdCookie(): Promise<string> {
	const existing = await getDeviceIdCookie();

	if (existing) return existing;

	const value = createId();
	await setDeviceIdCookie(value);

	return value;
}

export async function refreshOrCreateDeviceIdCookie(): Promise<string> {
	const value = (await getDeviceIdCookie()) ?? createId();
	await setDeviceIdCookie(value);

	return value;
}
